// Shared XP/level formulas — mirror cmd/games/record/main.go on the backend so
// pre-game level (rendered on Home) and post-game leveledUp (returned by the
// server) always agree. Single source of truth lives here; the backend just
// reapplies the same arithmetic.
//
//   level = floor(sqrt(xp / 50)) + 1
//
// Level 1 at 0xp, 2 at 50, 3 at 200, 4 at 450, … quadratic curve so progression
// slows down over time (classic gamification feel).

export function xpToLevel(xp: number): number {
  if (!Number.isFinite(xp) || xp <= 0) return 1
  return Math.floor(Math.sqrt(xp / 50)) + 1
}

// xpForLevel returns the cumulative XP required to reach the given level.
// Inverse of xpToLevel: xpForLevel(xpToLevel(xp) + 1) is the next threshold.
export function xpForLevel(level: number): number {
  if (level <= 1) return 0
  const n = level - 1
  return n * n * 50
}

// Progress within the current level: { current, needed, percent } where
// `current` is the XP into the current level, `needed` is the gap from this
// level's threshold to the next, and `percent` is current/needed * 100. Useful
// for rendering a progress bar without leaking the formula into every caller.
export function levelProgress(xp: number): {
  level: number
  current: number
  needed: number
  percent: number
} {
  const level = xpToLevel(xp)
  const floor = xpForLevel(level)
  const next = xpForLevel(level + 1)
  const needed = Math.max(next - floor, 1)
  const current = Math.max(xp - floor, 0)
  const percent = Math.min(Math.round((current / needed) * 100), 100)
  return { level, current, needed, percent }
}
